/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Grid, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CarouselComponent from "../../shared/components/reusableComp/CarouselComponent";
import { useEffect, useRef, useState } from "react";
import {
  DESKTOP_VIEW_WIDTH,
  TAB_VIEW_WIDTH,
} from "../../shared/constants/constants";
import TabViewCarousel from "../../shared/components/reusableComp/TabViewCarousel";
import { getcarModelLanding } from "./carModelApi";
import { useParams } from "react-router-dom";
import IndustryTabView from "../../shared/components/reusableComp/IndustryTabView";
import QuickLinksComp from "../../shared/components/reusableComp/QuickLinksComp";

const carouselStyle = (matches, matchesTab) => css`
  background: #121212;
  scroll-margin-top: ${(matches && "80px") || (matchesTab && "69px") || "56px"};
  height: 50vw,
  min-height: 70vh;
`;

const industrycarouselStyle = (matches, matchesTab) => css`
  background: #121212;
  height: 20vw,
  min-height: 20vh;
  padding: ${matches ? "0 40px" : "30px 0"};
  scroll-margin-top: ${(matches && "80px") || (matchesTab && "69px") || "56px"};
`;

const quickContainerCss = (matches) => css`
  display: flex;
  justify-content: space-around;
  padding-top: 20px;
  margin-bottom: 40px;
  display: flex;
  justify-content: ${matches ? "center" : "space-evenly"};
  align-items: center;
`;

const useStyles = makeStyles({
  quickLinks: {
    width: "35.417%",
    height: "26.042vw",
    backgroundColor: "#9b9b9b",
    position: "relative",
  },
});
function CarModel({ Slug }) {
  const [carouselData, setCarouselData] = useState([]);
  const [tabViewCarouselData, setTabViewCarouselData] = useState([]);
  const [quickLinksData, setQuickLinksData] = useState([]);
  const [industryTabData, setIndustryTabData] = useState([]);
  const matches = useMediaQuery(DESKTOP_VIEW_WIDTH);
  const matchesTab = useMediaQuery(TAB_VIEW_WIDTH);
  const styles = useStyles();
  const myRef = useRef();
  const industryRef = useRef();
  const { slug } = useParams();

  useEffect(() => {
    slug &&
      getcarModelLanding(slug || Slug).then(({ data }) => {
        document.title = data?.data?.attributes?.title;
        data?.data?.attributes?.body?.map((item) => {
          if (item.__component === "components.slider") {
            setCarouselData([...item.slides]);
          } else if (item.__component === "components.list") {
            setQuickLinksData([...item.ctaList]);
          } else if (item.__component === "components.tabs") {
            setTabViewCarouselData([...item.tabs]);
          } else if (item.__component === "components.industry-tabs") {
            setIndustryTabData([...item.industryTab]);
          }
        });
      });
  }, [slug]);

  const handleScroll = () => {
    if (tabViewCarouselData.length > 0)
      myRef.current.scrollIntoView({ behavior: "smooth" });
    else industryRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App" style={{ zIndex: "-1", marginTop: "" }}>
      <Grid container style={{ background: "#121212" }}>
        {carouselData.length > 0 && (
          <Grid item className={`${styles.carousel}`} xs={12}>
            <CarouselComponent
              carouselData={carouselData}
              handleScroll={handleScroll}
            />
          </Grid>
        )}

        {tabViewCarouselData.length > 0 && (
          <Grid
            ref={myRef}
            item
            css={() => carouselStyle(matches, matchesTab)}
            xs={12}
          >
            <TabViewCarousel tabViewCarouselData={tabViewCarouselData} />
          </Grid>
        )}
        {industryTabData.length > 0 && (
          <Grid
            ref={industryRef}
            item
            css={() => industrycarouselStyle(matches, matchesTab)}
            xs={12}
          >
            <IndustryTabView industryTabData={industryTabData} />
          </Grid>
        )}

        {quickLinksData.length >= 0 && (
          <Grid item css={() => quickContainerCss(matches)} xs={12}>
            <QuickLinksComp quickLinksData={quickLinksData} />
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default CarModel;
